import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { ResearchContainer } from '@containers/ResearchContainer';
import { PageContainer } from './Research.styles';

export default function Research() {
  return (
    <PageContainer>
      <PageHeader 
        title="Research" 
        description="Search through your embedded documents for relevant legal information"
      />
      <ResearchContainer />
    </PageContainer>
  );
};